import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Col,
  Row,
  FormGroup,
  Image,
  ListGroup,
  ListGroupItem
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Campaign from '../../images/campaign.png';
import Booking from '../../images/campaign.png';
import LocationSelect from '../LocationSelect';
import { Building } from '../../components/Icons';
import InfoIcon from '../../components/InfoIcon';
import User from '../../images/user.png';
import { getSetting } from '../../actions/settings/settingsCreators';

class LocationMenu extends Component {
  hasPermission = name =>
    this.props.permissions.find(p => p.permissionName === name);

  componentDidMount() {
    const { getSetting } = this.props;
    getSetting('subAccountHeadingInfoHoverText');
    getSetting('subAccountCampaignsInfoHoverText');
    getSetting('subAccountUsersInfoHoverText');
    getSetting('subAccountBookingsInfoHoverText');
    getSetting('subAccountDetailsInfoHoverText');
  }

  render() {
    const {
      closeMenu,
      currentLocation,
      currentOrganisation,
      settings
    } = this.props;
    const disabled = !currentLocation.id;
    return (
      <div className="location-menu">
        <h2>
          Sub-Accounts
          {settings && settings.subAccountHeadingInfoHoverText && (
            <InfoIcon placement="bottom">
              {settings.subAccountHeadingInfoHoverText.value}
            </InfoIcon>
          )}
        </h2>
        <div className="module">
          {this.props.image && (
            <Image src={this.props.image} alt="" responsive />
          )}
          <Row>
            <Col xs={12}>
              <FormGroup controlId="main-menu-location-select">
                <LocationSelect {...this.props} />
              </FormGroup>
            </Col>
          </Row>

          <ListGroup>
            <ul>
              {this.hasPermission('User') && (
                <li className="campaigns">
                  <LinkContainer
                    to={`/sub-account/${currentLocation.id}/campaigns`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Image src={Campaign} className="dashboard-icon" alt="" />{' '}
                      Campaigns
                      {settings &&
                        settings.subAccountCampaignsInfoHoverText && (
                          <InfoIcon>
                            {settings.subAccountCampaignsInfoHoverText.value}
                          </InfoIcon>
                        )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}
              {this.hasPermission('User') && (
                <li className="bookings">
                  <LinkContainer
                    to={`/sub-account/${currentLocation.id}/bookings`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Image src={Booking} className="dashboard-icon" alt="" />{' '}
                      Bookings
                      {settings && settings.subAccountBookingsInfoHoverText && (
                        <InfoIcon>
                          {settings.subAccountBookingsInfoHoverText.value}
                        </InfoIcon>
                      )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}

              {this.hasPermission('Admin') && (
                <li className="users">
                  <LinkContainer
                    to={`/sub-account/${currentLocation.id}/users`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Image src={User} className="dashboard-icon" alt="" />{' '}
                      Users
                      {settings && settings.subAccountUsersInfoHoverText && (
                        <InfoIcon>
                          {settings.subAccountUsersInfoHoverText.value}
                        </InfoIcon>
                      )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}

              {this.hasPermission('Admin') && (
                <li className="account-details">
                  <LinkContainer
                    to={`/sub-account/${currentOrganisation.id}/sub-accounts/${
                      currentLocation.id
                    }`}
                    onClick={closeMenu}
                    disabled={disabled}
                  >
                    <ListGroupItem className="no-underline">
                      <Building height="32px" width="32px" /> Sub-Account
                      Details
                      {settings && settings.subAccountDetailsInfoHoverText && (
                        <InfoIcon>
                          {settings.subAccountDetailsInfoHoverText.value}
                        </InfoIcon>
                      )}
                    </ListGroupItem>
                  </LinkContainer>
                </li>
              )}
            </ul>
          </ListGroup>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getSetting
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationMenu);



// WEBPACK FOOTER //
// ./src/components/menuItems/LocationMenu.js